import { Request, getParamsUrl } from '@/core'
import { control } from '@/constants/urls'

export default {
  get: params => Request.get(`${control.whitelist}${getParamsUrl(params)}`),
  create: data => Request.post(control.whitelistCreate, data),
  update: data => Request.post(control.whitelistUpdate, data),
  delete: id => Request.post(control.whitelistDelete, { id }),
  download: params =>
    Request.get(`${control.whitelistDownload}${getParamsUrl(params)}`),
}
